<template>
  <div
    class="BtnEdit  flex-row flex__left padding-top-5 padding-bottom-5 padding-left-10 padding-right-10 margin-right-10 border-radius__3 btnStyle"
  >
    <el-tooltip
      placement="top"
      v-for="buttonConfig in buttonConfigs"
      :key="buttonConfig.value"
    >
      <div slot="content">{{ buttonConfig.label }}</div>
      <el-button
        size="mini"
        class="btn-none__border"
        :disabled="disabled"
        @click="alignChanged(buttonConfig.value)"
      >
        <i :class="[buttonConfig.iconClass]"></i>
      </el-button>
    </el-tooltip>
  </div>
</template>

<script>

  export default {
    name: "canvas-buttons-group",
    props: ["disabled", "buttonConfigs"],
    data() {
      return {};
    },
    methods: {
      alignChanged(align) {
        this.$emit("alignChanged", align);
      }
    }
  };
</script>

<style scoped>
  .btnStyle{
    border-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/canvas-buttons-group.vue